import { Scope } from '@pubstack/common/src/scope'
import { ChangeEvent, FC, PropsWithChildren, useEffect, useRef, useState } from 'react'
import { BaseInputElement as BaseInput } from '~/components/Input'
import { useSwitchScope } from '~/hooks/useSwitchScope'

const ScopesPopoverContentNoResult: FC<PropsWithChildren<{ currentFilterValue: string }>> = ({ currentFilterValue }) => {
  return (
    <div className={'mx-auto max-w-[200px] p-4 text-center'}>
      <h5>No results</h5>
      <p>
        We found no results for "{currentFilterValue}".
        <br />
        Check the spelling or use another word.
      </p>
    </div>
  )
}

const ScopesPopoverContent: FC<PropsWithChildren<{ scopes: Scope[] }>> = ({ scopes }) => {
  const switchScope = useSwitchScope()
  const [displayedScopes, setDisplayedScopes] = useState([...scopes])
  const [inputScope, setInputScope] = useState('')
  const filterScopes = (event: ChangeEvent<HTMLInputElement>) => {
    setInputScope(event.target.value)
    setDisplayedScopes(scopes.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
  }
  const inputElement = useRef<HTMLInputElement>(null)
  useEffect(() => {
    inputElement.current?.focus()
  })

  const ScopesItems = displayedScopes.map((scope, index) => (
    <div className={'block cursor-pointer px-3 py-2 select-none hover:bg-topaze'} onClick={() => switchScope(scope.id)} key={index}>
      {scope.name}
    </div>
  ))

  return (
    <div className={'flex flex-col'}>
      <div className={'flex flex-row items-center p-3'}>
        <BaseInput iconLeft={'search'} type={'text'} labelIsPlaceholder label={'Search'} onChange={filterScopes} ref={inputElement} />
      </div>
      {displayedScopes.length ? (
        <div className={'flex max-h-[350px] flex-col overflow-auto [scrollbar-color:var(--color-silver)_var(--color-cloud)] [scrollbar-width:thin]'}>{ScopesItems}</div>
      ) : (
        <ScopesPopoverContentNoResult currentFilterValue={inputScope} />
      )}
    </div>
  )
}

export default ScopesPopoverContent
